export enum PackagePricingType {
  "SUM_INSURANCES" = "SUM_INSURANCES",
  "ALL_REMAINING" = "ALL_REMAINING",
  // "SET_OWN_PRICE" = "SET_OWN_PRICE",
}
